const OVERVIEW_CATEGORY = '0cafa662-e431-4768-8522-2f96c814822b';
export const HIDDEN_CATEGORIES = [OVERVIEW_CATEGORY];
